module.exports = __webpack_public_path__ + "img/Mexicain.fc08d85.jpg";